import { MapPin } from "lucide-react";
import { Reveal } from "./Reveal";
import { RequestButton, WhatsAppButton } from "./Buttons";

export default function ServiceArea() {
  return (
    <section className="relative py-24 md:py-36 overflow-hidden" data-testid="service-area-section">
      <img src="/images/bench.jpg" alt="" aria-hidden className="absolute inset-0 h-full w-full object-cover opacity-[0.18] grayscale" loading="lazy" />
      <div className="absolute inset-0 bg-gradient-to-b from-[var(--ink)] via-[var(--ink)]/70 to-[var(--ink)]" aria-hidden />
      <div className="relative mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal>
          <p className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.2em] text-[var(--mute)]"><MapPin className="h-4 w-4 text-[var(--red)]" aria-hidden /> Service area</p>
          <h2 className="mt-6 font-display font-black uppercase leading-[0.86] text-[13vw] md:text-8xl lg:text-[9rem]">
            Newcastle<br /><span className="stroke-text">&amp; the</span> North East
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="mt-10 grid md:grid-cols-12 gap-8 items-end">
          <p className="md:col-span-6 text-sm md:text-base text-[var(--grey)] leading-relaxed max-w-lg">Based in Newcastle upon Tyne and helping tool owners across the North East of England. Get in touch to check what's possible for your tool and location.</p>
          <div className="md:col-span-6 flex flex-col sm:flex-row md:justify-end gap-3">
            <RequestButton testId="area-request-repair-btn" />
            <WhatsAppButton testId="area-whatsapp-btn" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
